
import { Components, Theme } from '@mui/material/styles';


export const overrides: Components<Theme> = {
//   MuiButton: Button,
};


